import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { map } from "rxjs/operators";
import * as _ from 'lodash';
import { BusinessUnit, Country, CacheService } from 'mapfre-auditlib';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class ProcessService {

  className = 'ProcessService';
  treeClasified;

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getCorporativeMap(businessUnit, entity, version = "latest", cache?, cacheKey = "corporativeMap"): Observable<any> | any {
    let params: any = {}
    if (version) {
      params.version = version;
    }
    if (entity) {
      params.entityId = entity.idEntityPk;
    }
    if (this.cacheService.canUseCache(cacheKey, [businessUnit.idUnitBusinessPk, _.get(entity,'idEntityPk'), version]) && cache) {
      return this.cacheService.getCacheData(cacheKey, [businessUnit.idUnitBusinessPk, _.get(entity,'idEntityPk'), version]);
    } else {
      let observable = this.http.get<any>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit.idUnitBusinessPk}`, { params }).pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey, [businessUnit.idUnitBusinessPk, _.get(entity,'idEntityPk'), version])
        return res;
      }))
      this.cacheService.updateCacheReq(cacheKey, [businessUnit.idUnitBusinessPk, _.get(entity,'idEntityPk'), version]);
      return observable;
    }
  }

  getSimpleCorporativeMap(businessUnit, version = "latest", cache = true, cacheKey= "simpleCorporativeMap"): any {
    let params: any = {}
    if (businessUnit) {
      cacheKey = cacheKey+"_"+businessUnit.idUnitBusinessPk.toString();
    }

    if (version) {
      cacheKey = cacheKey+"_"+version.toString();
      params.version = version;
    }
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit.idUnitBusinessPk}`, { params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getLocalMap(businessUnit, entityID, jobId?: string, cache = true, version = "latest", cacheKey = "localMap"): Observable<any> |any {
    let params: any = {}
    if (businessUnit) {
      cacheKey = cacheKey+"_"+businessUnit.idUnitBusinessPk.toString()
    }
    if (version) {
      cacheKey = cacheKey+"_"+version.toString()
      params.version = version;
    }
    if (entityID) {
      cacheKey = cacheKey+"_"+entityID.toString()
    }
    if (jobId) {
      cacheKey = cacheKey+"_"+jobId.toString()
    }

    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit.idUnitBusinessPk}/country-process/${entityID}`, { params }).pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey)
        return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getProcess(readonly, businessUnit, country, version = "latest") {
    if (!readonly) {
      return this.getSimpleCorporativeMap(businessUnit, version).pipe(map(res => {
        this.treeClasified = {};
        this.prepareNodes(res);
        return this.treeClasified;
      }))
    }
    return of(false);
  }

  getSubprocess(readonly, businessUnit, country, version = "latest") {
    if (!readonly) {
      return this.getSimpleCorporativeMap(businessUnit, version).pipe(map(res => {
        this.treeClasified = {};
        this.prepareNodes(res);
        return this.treeClasified['SUB_PROCESO'];
      }))
    }
    return of(false);
  }


  prepareNodes(tree) {
    _.map(tree, (node: any) => {
      if (!_.find(_.keysIn(this.treeClasified), it => it === node.data.typeProcess.cdTypeProcess)) {
        _.assign(this.treeClasified, { [node.data.typeProcess.cdTypeProcess]: [node.data] });
      }
      else {
        if (!_.find(this.treeClasified[node.data.typeProcess.cdTypeProcess], (it: any) => it.idProcessPk === node.data.idProcessPk)) {
          this.treeClasified[node.data.typeProcess.cdTypeProcess].push(node.data);
        }
      }

      if (node.children) {
        this.prepareNodes(node.children);
      }
    });
  }

  // TODO: country -> entity
  saveMap(businessUnit, country, map) {
    let pathParams = country ? `${businessUnit.idUnitBusinessPk}/${country.idCountryPk}` : `${businessUnit.idUnitBusinessPk}`
    let cleanMap = this.cleanTree(map, country);
    return this.http.post<any>(`${environment.base_URL}/business-processes`, cleanMap);
  }

  cleanTree(tree, country) {
    return _.map(tree, (n) => {
      return this.cleanNodeDepth(n, country);
    })
  }

  cleanNodeDepth(node, country) {
    delete node.parent;
    node.data.size = _.get(node, 'form.value.size') ? Number(_.get(node, 'form.value.size')) : Number(_.get(node,'data.size')) > 0 ? Number(_.get(node,'data.size')) : 0;
    node.data.entamap = country;
    if (node.data.entity) {
      delete node.data.entity;
    }
    delete node.form;
    if (node.children) {
      node.children = _.map(node.children, (c) => {
        return this.cleanNodeDepth(c, country);
      })
    }
    return node
  }

  deleteCache() {

    let memoryCache = ["process", "processMap"];

    _.forEach(memoryCache, item => {
      this.cacheService.deleteCache(item);
    })

  }
}

